const TestimonialApi = [
  {
    id: 1,
    image: "/assets/17.jpg",
    design: "9 grudnia 2014",
    name: "Z przymróżeniem oka",
    officer: "Łukasz Kielban",
    post: "Nietuzinkowy Klub Dżentelmenów według Dickensa",
    date: "czasgentlemanow.pl/2014/12/nietuzinkowy-klub-dzentelmenow-wedlug-dickensa",
    desc: "Klub Pickwicka ukazuje klub dżentelmeński w krzywym zwierciadle. Nie znajdziesz tu niczego, co kojarzyło ci się z tego rodzaju stowarzyszeniami: elitarności, wytworności, tajemniczości i powagi. Oczywiście Klub Pickwicka ma swój statut, sekcję korespondencyjną, a ubrania członków mają specjalne, złote guziki z inicjałami klubu.",
  },
  {
    id: 2,
    image: "/assets/18.jpg",
    design: "06 września 2013",
    name: "Literacka kanciapa",
    officer: "Krzysztof Chmielewski",
    post: "Blog nie tylko o książkach...",
    date: "literacka-kanciapa.blogspot.com/2013/09/recenzja-klub-pickwicka-charles-dickens.html",
    desc: "Na swej drodze, czwórka przyjaciół, bo tylu ich się w podróż wybiera, napotyka na liczne przeszkody. A to trafiają do więzienia, a to główny bohater zostaje posądzony o zerwanie ślubów narzeczeńskich, czasami zdarza się bójka w której prym wiedzie lokaj głównego bohatera, kradzieże, pościgi … sporo tego. Można by rzec – komedia sensacyjna.",
  },
  {
    id: 3,
    image: "/assets/19.jpg",
    design: "16 grudnia 2016",
    name: "Kochany pan Pickwick",
    officer: "Joanna Kapica-Curzytek",
    post: "Charles Dickens „Klub Pickwicka” - recenzja",
    date: "esensja.pl/ksiazka/recenzje/tekst.html?id=23891",
    desc: "Powieść doczekała się pastiszy, licznych adaptacji, a nawet – kontynuacji. Powstały też liczne towarzystwa i kluby, na wzór tego powołanego do życia przez Dickensa. Niektóre działają nawet do dzisiaj. „Klub Pickwicka” jest jednak jedyny w swoim rodzaju i będzie istniał oczywiście dopóty, dopóki po tę książkę będą sięgać czytelnicy. Tak będzie na pewno – Samuel Pickwick należy przecież do najbardziej znanych i ukochanych postaci literackich.",
  },
  {
    id: 4,
    image: "/assets/20.jpg",
    design: "06 lutego 2017",
    name: "Bardzo nudny klub",
    officer: "Katarzyna Prędotka",
    post: "W tej książce wszystko wydaje się za długie",
    date: "zcyklu.pl/na-czasie/recenzje/bardzo-nudny-klub",
    desc: "Czytając tę książkę, miałam wrażenie, że autor chciał w niej pokazać to, co w swoim pisarstwie ma najlepszego, przez co uzyskał odwrotny skutek. W tej książce jest wszystko, a tego co się tam znajduje jest zdecydowanie za dużo. Ta powieść to świadectwo samouwielbienia pisarza, w które Charles Dickens popadł – jak widać, już na samym początku swojej drogi zawodowej. Tej historii zdecydowanie dobrze by zrobił czas, który by spędziła czekając cierpliwe na swoją kolej w wydawnictwie.",
  },
  {
    id: 5,
    image: "/assets/21.jpg",
    design: "16 listopada 2016",
    name: "Z uwielbienia do literatury",
    officer: "Kasia",
    post: "Przygody Pana Pickwicka",
    date: "niebieskapapuzka.wordpress.com/2016/11/16/przygody-pana-pickwicka",
    desc: "Niewiele jest dzieł, które w tak otwarty sposób mówią nam prawdę o życiu w danej epoce – wszystkich trudach i znojach każdego dnia. Dickens właśnie to robi, dlatego warto poświęcić mu parę dłuższych jesiennych bądź zimowych wieczorów i poznać dobrodusznego Pickwicka, któremu wiatr zawsze w oczy dmucha.",
  },
];

export default TestimonialApi;
